// import compiled language files
import messagesEn from '../compiled-lang/en.json';
import messagesEs from '../compiled-lang/es.json';

/**
 * Get the browser's configured language EX: 'en' or 'de'
 * @returns {string} browser's language string without the country code
 */
const getLocale = () => {
  return navigator.language.split(/[-_]/)[0];
};

/**
 * Returns the language translation object for the current browser language
 * @returns {object} JSON Object containing translated messages
 */
const getMessages = () => {
  return (() => {
    switch (getLocale()) {
      // add new languages as cases here.
      case 'es':
        return messagesEs;
      default:
        return messagesEn;
    }
  })();
};

export { getMessages, getLocale };
